import * as React from 'react';

import { useParsers } from '../../hooks';
import { BasketSummaryDetails, UseParsers } from '../../interfaces';

import { InnerContainer, BasketSummaryItem, Container, Description } from './basketSummary.styled';
import { BasketSummaryProps } from './basketSummary.types';

export const BasketSummary: React.FC<BasketSummaryProps> = (props: BasketSummaryProps): JSX.Element => {
  const { items, currency = 'zł', description, className }: BasketSummaryProps = props;
  const { parsePrice }: UseParsers = useParsers();

  return (
    <Container className={className}>
      {items
        .filter((item: BasketSummaryDetails): boolean => !!item.label)
        .map((item: BasketSummaryDetails, index: number): JSX.Element => 
          <InnerContainer 
            $isLastItem={items[items.length - 1].label === item.label} 
            key={`${item.label} + ${index}`}
          >
            <BasketSummaryItem>{item.label}</BasketSummaryItem>
            <BasketSummaryItem>{parsePrice(item.price)} {currency}</BasketSummaryItem>
          </InnerContainer>
        )}
      {description && <Description>{description}</Description>}
    </Container>
  );
};
